import { i18n } from 'next-i18next';
import * as gtag from '~/../libs/gtag';

export function editURLInBrowser(url) {
  const locale = i18n.language;
  if (locale === 'ja') {
    window.history.pushState(
      {
        ...window.history.state,
        as: url,
        url: url,
      },
      '',
      url,
    );
  } else {
    url = `/${locale}${url}`;
    window.history.pushState(
      {
        ...window.history.state,
        as: url,
        url: url,
      },
      '',
      url,
    );
  }
  gtag.pageview(url);
}
